import { connect } from 'react-redux';

import MembersSortFieldMobilePlain from './member-sort-field-mobile';
import MembersSortFieldDesktopPlain from './member-sort-field-desktop';

export const MembersSortFieldMobile = connect()(MembersSortFieldMobilePlain);
export const MembersSortFieldDesktop = connect()(MembersSortFieldDesktopPlain);
